import React from 'react';
import { bool, func, node, object, oneOfType, shape, string } from 'prop-types';

import Field, { hasDataInFields } from '../../Field';
import SectionContainer from '../SectionContainer';
import ListingsContent from '../../../LandingPage/components/SectionListings/SectionListings';

const getTitleString = title => {
  if (typeof title === 'string') {
    return title;
  }
  if (title && typeof title.content === 'string') {
    return title.content;
  }
  return '';
};

const getFiltersFromListingSelection = listingSelection => {
  if (listingSelection == null) {
    return {};
  }
  let selection = listingSelection;
  if (typeof listingSelection === 'string') {
    try {
      selection = JSON.parse(listingSelection);
    } catch {
      return {};
    }
  }
  if (typeof selection !== 'object' || selection === null) {
    return {};
  }
  if (selection.filters && typeof selection.filters === 'object') {
    return selection.filters;
  }
  return { ...selection };
};

const SectionListings = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    listingSelection,
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasTitleInHeader = hasDataInFields([title], fieldOptions);
  const titleString = getTitleString(title);
  const filters = getFiltersFromListingSelection(listingSelection);
  const listingsTitle = hasTitleInHeader ? '' : titleString;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses?.sectionDetails}>
          <Field data={title} className={defaultClasses?.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses?.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses?.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      <ListingsContent title={listingsTitle} startFrom={0} filters={filters} />
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionListings.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  listingSelection: null,
  isInsideContainer: false,
  options: null,
};

SectionListings.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: oneOfType([object, string]),
  description: object,
  appearance: object,
  callToAction: object,
  listingSelection: oneOfType([object, string]),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionListings;
